import React from 'react';
import * as styles from './list-columns.module.css'

export default ({ title, items = [] }) => {
  return (
    <div className={styles.listColumnsWrapper}>
      <h3 className={styles.listColumnHeader}>{title}</h3>
      <div className={styles.columns}>
        {items.map((d, i) => {
          return (
            <div key={i} className={styles.listColumnItem}>
              {d.list_column_item.text}
            </div>
          )
        })}
      </div>
    </div>
  )
}